<template>
  <v-layout wrap>
    <v-flex xs12 sm8 d-flex justify-center align-center order-xs2 order-sm1
            class="title text-xs-center text-sm-left">
            <span class="mb-0"
                  :class="{subheading: $vuetify.breakpoint.width <= 720 && $vuetify.breakpoint.width >= 600, 'mt-3': $vuetify.breakpoint.xsOnly}">
              {{title}} № {{id}} от {{format(new Date(created_on), 'DD.MM.YYYY')}}
            </span>
    </v-flex>
    <v-flex xs12 sm4 class="text-sm-right text-xs-center" nowrap order-xs1 order-sm2 justify-end align-end>
      <v-tooltip bottom v-if="addItems">
        <v-btn
          slot="activator"
          icon
          color="grey"
          dark
          @click="$router.push({name: 'catalog/document', params: {docId: id, docName: name}})"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <span>Добавить товары</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          icon
          color="grey"
          dark
          @click="openDocument"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <span>Обновить</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          @click="closeDocument"
          color="grey"
          dark
          icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Закрыть</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'DocumentToolbar',
  props: {
    addItems: {
      default: true,
      type: Boolean
    },
    title: {
      default: '',
      required: true,
      type: String
    },
    created_on: {
      default: '',
      required: true,
      type: String
    },
    id: {
      default: '',
      required: true
    },
    name: {
      default: '',
      required: true,
      type: String
    }
  },
  data () {
    return {
      format
    }
  },
  methods: {
    openDocument () {
      this.$emit('openDocument')
    },
    closeDocument () {
      this.$emit('closeDocument')
    }
  }
}
</script>

<style scoped>

</style>
